(() => {
  const W = window.WR || {};
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (_) {}
  if (!location.hash) {
    window.scrollTo(0, 0);
    window.addEventListener('pageshow', () => window.scrollTo(0, 0));
  }
  const pad = (n) => String(n).padStart(2, '0');
  const resteAvant22h = () => {
    const now = new Date();
    const p = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
    const cut = new Date(p); cut.setHours(22, 0, 0, 0);
    let demain = false;
    if (p >= cut) { cut.setDate(cut.getDate() + 1); demain = true; }
    return { s: Math.floor((cut - p) / 1000), demain };
  };
  const add = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w !== 6) k++; } return d; };
  const f = (d) => d.toLocaleDateString(W.loc || 'de', { weekday: 'short', day: 'numeric', month: 'short' });
  const tic = () => {
    const r = resteAvant22h();
    const t = pad(Math.floor(r.s / 3600)) + ':' + pad(Math.floor((r.s % 3600) / 60)) + ':' + pad(r.s % 60);
    document.querySelectorAll('[data-wr-cut]').forEach((el) => {
      const modele = r.demain ? el.dataset.m : el.dataset.h;
      if (modele) el.innerHTML = modele.replace('{t}', t);
    });
    document.querySelectorAll('[data-wr-arrivee]:not([data-ok])').forEach((el) => {
      if (!W.between) return;
      el.innerHTML = W.between.replace('{a}', '<b>' + f(add(Number(el.dataset.min || 3))) + '</b>').replace('{b}', '<b>' + f(add(Number(el.dataset.max || 5))) + '</b>');
      el.setAttribute('data-ok', '');
    });
  };
  tic(); setInterval(tic, 1000);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-wr-ruban]').forEach((piste) => {
    let pause = false, visible = false, pret = false, t, pos = 0;
    const moitie = () => piste.scrollWidth / 2;
    const stop = () => { pause = true; clearTimeout(t); t = setTimeout(() => { pause = false; pos = piste.scrollLeft; }, 4000); };
    ['pointerdown', 'touchstart', 'wheel', 'mouseenter'].forEach((ev) => piste.addEventListener(ev, stop, { passive: true }));
    piste.addEventListener('mouseleave', () => { pause = false; pos = piste.scrollLeft; });
    const go = () => {
      if (visible && !pause && !document.hidden && moitie() > piste.clientWidth) {
        if (!pret) { pos = moitie(); pret = true; }
        if (pos <= 1) pos = moitie();
        pos -= 0.5;
        piste.scrollTo({ left: pos, behavior: 'instant' });
      }
      requestAnimationFrame(go);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((es) => es.forEach((en) => { visible = en.isIntersecting; })).observe(piste);
    }
    window.addEventListener('scroll', function once() { window.removeEventListener('scroll', once); requestAnimationFrame(go); }, { passive: true, once: true });
  });
})();
